// extracted by mini-css-extract-plugin
module.exports = {"pageHeader":"ExtrasList_pageHeader__1iaQm"};